<template>
  <div id="app">
    <player
      ref="player"
      v-show="player_visible"
      v-on:show-assets="show_assets"
      v-bind:assetuuid="player_asset_id"
      v-on:dialog-message="dialog_message"
      ></player>
    <assets
      ref="assets"
      v-show="assets_visible"
      v-on:show-player="show_player"
      v-on:set-asset-info="set_asset_info"
      v-on:show-user="show_user"
      ></assets>
    <signin
      v-show="signin_visible"
      v-on:dialog-message="dialog_message"
      v-on:show-assets="show_assets"
      ></signin>
    <sleep
      v-show="sleep_visible"
      ></sleep>
    <user
      ref="user"
      v-show="user_visible"
      v-on:show-assets="show_assets"
      v-on:show-signin="show_signin"
      ></user>
    <!--<router-view/> -->
    <v-dialog></v-dialog>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Player from '@/components/Player'
import Assets from '@/components/Assets'
import Signin from '@/components/Signin'
import Sleep from '@/components/Sleep'
import User from '@/components/User'
import * as srv from './srv'
import * as storage from './storage'

export default {
  name: 'app',
  components: {
    'player': Player,
    'assets': Assets,
    'signin': Signin,
    'sleep': Sleep,
    'user': User
  },
  data () {
    return {
      player_visible: false,
      player_asset_id: '',
      assets_visible: false,
      signin_visible: false,
      sleep_visible: false,
      user_visible: false
    }
  },
  methods: {
    dialog_message (msg, callback) {
      if (document.activeElement) {
        document.activeElement.blur()
      }
      this.$modal.show('dialog', {
        // title: `(${title})`,
        // title: 'SKILABOÐ',
        // text: `<pre>${msg}</pre>`,
        text: msg,
        width: '600px',
        buttons: [
          {
            title: 'Í lagi',
            handler: () => {
              callback()
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    hide_all () {
      this.player_visible = false
      this.assets_visible = false
      this.signin_visible = false
      this.sleep_visible = false
      this.user_visible = false
    },
    set_asset_info (asset_id, image) {
      // Til að triggera breyginu, til að fá kerfið til að load aftur kafla uppl, gert til að spilarinn merki sig sem núverand code hlustanda
      // console.log('BBBBBBBB')
      // this.player_asset_id = 'NONE'
      // this.player_asset_id = asset_id
      this.$refs.player.setup_paths(asset_id, image)
    },
    show_player (asset) {
      // console.log('APP show_player')
      this.hide_all()
      this.player_visible = true
    },
    show_assets () {
      // console.log('APP show_assets')
      this.$refs.assets.get_assets()
      this.hide_all()
      this.assets_visible = true
    },
    show_signin () {
      console.log('APP show_signin')
      this.hide_all()
      this.signin_visible = true
    },
    show_sleep () {
      // console.log('APP show_sleep')
      this.hide_all()
      this.sleep_visible = true
    },
    show_user () {
      // console.log('APP show_user')
      this.$refs.user.setup()
      this.hide_all()
      this.user_visible = true
    }
  },
  mounted () {
    // INTENTION: Ath hvort notandinn sé skráður inn, og staðfesta.
    if (storage.get_browser_id() && storage.get_user_id()) {
      srv.signin_browser()
        .then(data => {
          console.log('1')
          storage.user.username = data.username
          storage.user.fullname = data.fullname
          this.show_assets()
        })
        .catch(srv_err => {
          console.log('2', srv_err)
          this.show_signin()
        })
    } else {
      this.show_signin()
    }
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
/*
  text-align: center;



  width: 350px;
  height: 50px;
  background-color: white;
  margin: 15px auto;
  padding: 10px;
  text-align: left;
}
  */
}
.comp_body {
  margin: 0px auto;
  width: 350px;
  margin-top: 60px;
}
.comp_body_signin {
  margin: 0px auto;
  width: 350px;
  margin-top: 0px;
  text-align: center;
}
.comp_x {
  width: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
}

.comp_title {
  text-transform: uppercase;
  color:#9f0811;
  position: absolute;
  top: 0px;
  left: 0px;
}
.comp_forlagid_logo {
  position: absolute;
  top: 0px;
  right: 0px;
}
.comp_cmds {
  position: absolute;
  top: 30px;
  left: 0px;
  font-size: 12px;
}
.comp_assets {
  position: absolute;
  top: 70px;
  left: 0px;
}
.comp_no_assets {
  position: absolute;
  top: 70px;
  left: 0px;
}
.comp_userinfo {
  position: absolute;
  top: 50px;
  left: 10px;
}
.player_cover {
  position: absolute;
  top: 20px;
  left: 25px;
  border: 1px solid #e9e9e9;
}
.player_controls div{
  display: inline-block;
}
.player_title {
  position: absolute;
  top: 335px;
  width: 350px;
  text-align: center;
  font-size: 13px;
}
.player_slider {
  position: absolute;
  top: 360px;
  left: 25px;
}
.player_timeremaining{
  position: absolute;
  top: 385px;
  right: 25px;
  text-align: right;
  font-size: 10px;
}
.player_controls {
  position: absolute;
  top: 400px;
  left: 0px;
  width: 350px;
  text-align: center;
}
.player_toc {
  font-size: 12px;
  position: absolute;
  top: 485px;
  left: 35px;
}
.player_log {
  position: absolute;
  top: 0px;
  left: -350px;
  font-family: "Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter", monospace;
  font-size: 8px;
}
.player_data{
  position: absolute;
  top: 0px;
  left: 350px;
  font-family: "Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter", monospace;
  font-size: 8px;
}
.asset {
  width: 350px;
/* height: 50px; */
  background-color: white;
  margin: 15px auto;
  padding: 10px;
  text-align: left;
}
.asset:last-of-type {
  margin-bottom: 50px;
}
.asset_title {
  font-size: 16px;
}
.asset_author {
  font-size: 10px;
}
.asset_cover {
  float: left;
  margin-right: 10px;
  border: 1px solid #e9e9e9;
}
.asset_bar {
  position: relative;
  left: 10px;
}
.asset_bar .progress_bar {
  position: relative;
  top: -1px;
  width: 100px;
}
.asset_time_ramaining {
  font-size: 9px;
  padding-left: 5px;
}

.chapters_list {
  position: relative;
  top: 50px;
  margin: auto;
  max-width: 340px;
}
.chapter {
  margin-bottom: 3px;
  padding: 10px;
}
.chapter_selected{
  background-color:#f3f3f3;
}
/*.chapter:hover {
  background-color:#f3f3f3;
}*/
.chapter_title {
  width: 100%;
  text-align: left;
}

.chapter_bar {
  left: 10px;
}
.chapter_bar .progress_bar {
  position: relative;
  top: -1px;
  width: 100px;
}
.chapter_time {
  position: absolute;
  right: 0px;
  top: 7px;
  font-size: 9px;
}

div {
  -webkit-transform: translate3d(0, 0, 0)
}
body * {
  -webkit-backface-visibility:  hidden;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
body {
 -webkit-touch-callout: none;
  -webkit-user-select: none;
     -moz-user-select: -moz-none;
      -ms-user-select: none;
          user-select: none;
}
.air {
  margin: 10px 0;
}
.right {
  text-align: right;
}
.centerdiv{
  margin: auto;
  max-width: 300px;
}

.link2, .link2:link, .link2:visited {
	cursor: pointer;
  color: inherit;
	text-decoration: underline;
	text-decoration: none;
	border-bottom: 1px rgba(0,0,0,.2) solid;
}

.link, .link:link, .link:visited {
	cursor: pointer;
}

a:link {
  /* color: black; */
  color: inherit;
  text-decoration: unset;
}

/* visited link */
a:visited {
  color: inherit;
  text-decoration: unset;
}

/* mouse over link */
a:hover {
  color: inherit;
  text-decoration: unset;
}

/* selected link */
a:active {
  color: inherit;
  text-decoration: unset;
}

input[type="text"], input[type="password"] {
  /*-moz-border-radius:10px; /* Firefox */
  /*-webkit-border-radius: 10px; /* Safari, Chrome */
  /*-khtml-border-radius: 10px; /* KHTML */
  /*border-radius: 3px; /* CSS3 */
  padding: 10px;
  margin: 10px;
  border: 1px solid #d2d2d2;
}

 input[type="button"] {
  padding: 5px 10px;
  margin: 10px 0;
  background-color:#9f0811;
  color: white;
  border-width: 0px;
  text-transform: uppercase;
  cursor: pointer;
 }

.progress_bar{
  display: inline-block;
  border: 0px solid #e9e9e9!important;
  background-color: #e9e9e9!important;
}
.progress_done {
  color: #000!important;
  width: 0%;
  background-color: #9f0811!important;
  height:3px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue